import React from 'react';
import PropTypes from 'prop-types';
import { Button, Popover, PopoverBody, PopoverHeader } from 'reactstrap';

const WelcomePopover = ({ closeWelcomePopover, showWelcomePopover }) => {
  const content = `  
  <p>
    While you wait for your video visit, we welcome</br>
    you to our virtual waiting room.
  </p>
  <p>
    Click on the circular red dots on the screen to get helpful and interesting info about BSWH, health tips, and more!
  </p>
`;

  return (
    <Popover
      className='welcome-popover'
      container='waiting-room-container'
      fade={false}
      hideArrow={true}
      isOpen={showWelcomePopover}
      placement='bottom'
      target='welcome-popover-target'
    >
      <PopoverHeader>Welcome to the virtual neighborhood!</PopoverHeader>
      <PopoverBody>
        <div dangerouslySetInnerHTML={{ __html: content }} />
        <Button color='primary' onClick={closeWelcomePopover}>
          Got It
        </Button>
      </PopoverBody>
    </Popover>
  );
};

WelcomePopover.defaultProps = {
  closeWelcomePopover: () => {},
  showWelcomePopover: false,
};

WelcomePopover.propTypes = {
  closeWelcomePopover: PropTypes.func,
  showWelcomePopover: PropTypes.bool,
};

export default WelcomePopover;
